<template>
  <oie-product-carousel
    :id="id"
    :title="title"
    :products="products"
    @buy-product="handleAdditionalSell($event)"></oie-product-carousel>
</template>

<script>
import { mapGetters } from 'vuex'
import gtm from '@/core/enhanced-ecommerce-gtm'
import _ from 'lodash'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    products: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    gaListType: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters(['enableGtm']),
    productIds() { return _.map(this.products, product => product.id) }
  },
  methods: {
    async handleAdditionalSell($event) {
      const { addedProduct } = $event
      if (addedProduct && this.enableGtm) {
        const gtmObject = gtm.createGtmItem(
          addedProduct.itemId,
          addedProduct.displayName,
          addedProduct.item.purchasedToVehicle,
          addedProduct.item.purchasedOnCategory,
          this.formatPriceWithoutCurrency(addedProduct.price),
          1,
          this.gaListType)

        gtm.addToCart(gtmObject)
      }
    }
  }

}
</script>

<style>

</style>
